import React from 'react';
import { Tooltip, Box, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

function OverdueAttentionIndicator({ invoice }) {
    return (
        <Tooltip 
            title={
                <Box sx={{ p: 0.5 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5, color: '#fff' }}>
                        ⚠️ דרוש טיפול דחוף!
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#fff' }}>
                        חשבונית זו נמצאת בטיפול יותר מ-{invoice.groupSettings?.requiresAttentionDaysThreshold || 'N/A'} ימים ועוד לא טופלה
                    </Typography>
                </Box>
            }
            arrow
            placement="top"
        >
            <Box sx={{ 
                display: 'flex', 
                alignItems: 'center',
                backgroundColor: 'rgba(211, 47, 47, 0.1)',
                borderRadius: '50%',
                p: 0.5
            }}>
                <AccessTimeIcon 
                    sx={{ 
                        color: '#d32f2f', 
                        fontSize: 24,
                        animation: 'urgentPulse 1.5s infinite',
                        '@keyframes urgentPulse': {
                            '0%': { opacity: 1, transform: 'scale(1)' },
                            '50%': { opacity: 0.5, transform: 'scale(1.15)' },
                            '100%': { opacity: 1, transform: 'scale(1)' }
                        }
                    }} 
                />
            </Box>
        </Tooltip>
    );
}

export default OverdueAttentionIndicator;
